import { useEffect } from "react";
import { useContent } from "@/content/ContentContext";

export const MarketingScripts = () => {
    const { settings } = useContent();

    useEffect(() => {
        const gaId = settings?.ga4_id?.trim();
        if (gaId && !document.getElementById("ga4-script")) {
            const script = document.createElement("script");
            script.id = "ga4-script";
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
            document.head.appendChild(script);
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () {
                window.dataLayer.push(arguments);
            };
            window.gtag("js", new Date());
            window.gtag("config", gaId);
        }

        const pixelId = settings?.meta_pixel_id?.trim();
        if (pixelId && !window.fbq) {
            const n = (window.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            });
            n.queue = [];
            n.loaded = true;
            n.version = "2.0";
            const script = document.createElement("script");
            script.async = true;
            script.src = "https://connect.facebook.net/en_US/fbevents.js";
            document.head.appendChild(script);
            window.fbq("init", pixelId);
            window.fbq("track", "PageView");
        }
    }, [settings]);

    return null;
};
